import React from "react";
import getYouTubeId from "get-youtube-id";
import YouTube from "react-youtube";
import Button from "../Button/ButtonSolid";
import Link from "gatsby";
import PortableText from "./portableText";

const serializers = {
  types: {
    youtube: ({ node }) => {
      const { url } = node;
      const id = getYouTubeId(url);
      return <YouTube videoId={id} />;
    },
    iframe: ({ node }) => {
      const { url, height } = node;
      return <iframe title="Iframe" src={url} width="100%" height={`${height}px`} />;
    },
    button: ({ node }) => {
      const { action, label, slug } = node;
      if (action == "form") {
        return (
          <span
            data-modal-open="modal-contact"
            className="group relative overflow-hidden min-w-[184px] h-[51px] px-6 inline-flex items-center justify-center text-center font-body font-semibold no-underline whitespace-nowrap bg-primary-600 hover:bg-primary-600 text-white hover:text-white w-full lg:w-auto mb-8"
          >
            {label}
          </span>
        );
      } else {
        return <div>{label}</div>;
      }
    },
    table: ({ node }) => {
      const { rows } = node;
      if (rows) {
        return (
          <div className="w-full grid grid-cols-2 border-[1px] border-white mb-8">
            {rows.map((row, index) => (
              <>
                <div className="border-[1px] border-white p-1 border-collapse" key={index}>
                  <PortableText blocks={row.column1} />
                </div>
                <div className="border-[1px] border-white p-1 border-collapse" key={index}>
                  <PortableText blocks={row.column2} />
                </div>
              </>
            ))}
          </div>
        );
      }
    },
  },
  marks: {
    form: ({ children, mark }) => {
      switch (mark.formName) {
        case "Contact Us":
          return (
            <span
              data-modal-open="modal-contact"
              className="cursor-pointer !text-[#d58b45] hover:!text-[#b1753e]"
            >
              {children}{" "}
            </span>
          );
        default:
          return <span>{children}</span>;
      }
    },
  },
};

export default serializers;
